export default __webpack_public_path__ + "static/media/prepara.a0561836.svg";